import React from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { RiVoiceprintLine } from "react-icons/ri";
import { MdOutlineVoiceOverOff } from "react-icons/md";
import { BASE_URL } from "utils/utils";

const AudioOrder = ({ audio }) => {
  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        {audio ? (
          <div className="aspect-square w-fit cursor-pointer rounded-full transition-all hover:bg-blueSecondary">
            <RiVoiceprintLine size={25} />
          </div>
        ) : (
          <MdOutlineVoiceOverOff color="red" size={25} />
        )}
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold">
            تسجيل صوتي
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <audio
            src={BASE_URL + "/" + audio}
            controls
            className="w-full"
            crossOrigin="anonymous"
          />
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إغلاق</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default AudioOrder;
